/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Construct literal routes based on url config
 *      with site and locale references (ids and aliases) from each in your application config
 *
 * @param {array} routes - array of routes to be reconstructed
 * @return {array} - list of routes objects that has site and locale refs
 */
export const configureRoutes = (routes = []) => {
	if (!routes.length) {
		return [];
	}

	let outputRoutes = [];

	for (let i = 0; i < routes.length; i++) {
		const {path, prependLocale = true, ...rest} = routes[i];

		if (prependLocale) {
			if (path === '/') {
				outputRoutes.push({
					path: `/:locale/`,
					...rest
				});
			} else if (path === '*') {
				outputRoutes.push({
					path: `/:locale/${path}`,
					...rest
				});
			} else {
				outputRoutes.push({
					path: `/:locale${path}`,
					...rest
				});
			}
		} else {
			outputRoutes.push(routes[i]);
		}
	}
	// Remove any duplicate routes
	outputRoutes = outputRoutes.reduce((res, route) => {
		if (!res.some(({path}) => path === route.path)) {
			res.push(route);
		}

		return res;
	}, []);

	return outputRoutes;
};

/**
 * Generate a localized path for a given route and language.
 * If the language is provided and a localized path exists for that language,
 * return the localized path. Otherwise, return the default route.
 *
 * @param {Object} route - The route object containing language-specific paths.
 * @param {String} language - The language code for which to generate the localized path.
 * @returns {String} - The localized path if available, otherwise the default path.
 */
export const generateLocalizedPath = (route) => {
	// TODO: Should be add logic from DG, when LNCC will optimize localizable link
	return route;
};

/**
 * Retrieves a localizable path object by providing a path
 * or null if no matching localizable path object is found.
 * @param {String} path - The path to search for in the routes object.
 * @returns {null} - null
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getLocalizablePathNameByPath = (path) => {
	// TODO: Should be add logic from DG, when LNCC will optimize localizable link
	return null;
};

